// Mounts react-hot-toast's <Toaster> once at the app root. Tracks the toast
// position live (no remount) by subscribing to the position external store, so
// setToastPosition() instantly repositions existing and future toasts.
import { useSyncExternalStore } from 'react'
import { Toaster } from 'react-hot-toast'
import { getToastPosition, subscribeToastPosition } from '@/core/toast/toastSettings'

const ToastContainer = () => {
  const position = useSyncExternalStore(subscribeToastPosition, getToastPosition, getToastPosition)

  return (
    <Toaster
      position={position}
      gutter={13}
      containerStyle={{ inset: 16, zIndex: 'var(--z-toast)' }}
    />
  )
}

export default ToastContainer
